<!--
 * @Description: 充值弹层
 * @Date: -
-->
<template>
  <div>
    <el-dialog
      :visible="showDialog"
      width="900px"
      class="chartDia"
      @close="close"
    >
      <div slot="title" class="slotTit">充值</div>
      <div>
        <div class="colorBlock">对公账户充值</div>
        <div class="cont">
          <span>充值通道：</span>
          <el-select
            v-model="payPassagewayCode"
            :disabled="true"
            @change="getTableData"
          >
            <el-option
              v-for="item in BANK_MAPPING"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>

        <div class="cont">
          <span>公司名称：</span>
          <b>{{ ruleForm.companyName }}</b>
        </div>
        <div class="cont">
          <span>银行账号：</span>
          <b>{{ ruleForm.bfBankNumber }}</b>
        </div>
        <div class="cont">
          <span>开户行：</span>
          <b>{{ ruleForm.kaiHuHang }}</b>
        </div>
        <div v-if="payPassagewayCode === 'fyBank'" class="cont">
          <span>支行名称：</span>
          <b>{{ ruleForm.fySubBranchName }}</b>
        </div>
        <div class="cont">
          <span>联行号：</span>
          <b>{{ ruleForm.lianHangHao }}</b>
        </div>
      </div>
      <span>
        温馨提示：请通过网银将充值金额汇入对应账户，请切记使用对公账户打款方式。具体到账时间以收款银行到账时间为准。
      </span>
      <div>
        <div class="colorBlock">
          <p>近3笔充值记录</p>
          <el-button type="text" @click="showMore = true">查看更多</el-button>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          :stripe="true"
          :highlight-current-row="false"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="付款人"
            prop="bankAccName"
          />
          <!-- <el-table-column :show-overflow-tooltip="true" align="center" label="付款账号" prop="bankAcctNo" /> -->
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="收款人"
            prop="companyName"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="收款账号"
            prop="bfBankNumber"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="流水号"
            prop="outTradeNo"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="交易日期"
            prop="finishPayDt"
          >
            <template slot-scope="{ row }">
              {{ row.finishPayDt | transAllTime }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="金额"
            prop="amount"
          >
            <template slot-scope="{ row }">
              {{ row.amount | moneyFixed }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="充值通道"
            prop="amount"
          >
            <template slot-scope="{ row }">
              {{ payBankFormatter(row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="small"
                @click="$exportFile(row.bankPayVoucherUrl)"
                :disabled="!row.bankPayVoucherUrl"
              >
                下载回单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      v-if="showMore"
      :visible="true"
      width="950px"
      class="chartDia"
      @close="showMore = false"
    >
      <div slot="title" class="slotTit">充值记录</div>
      <rechargeRecord :payPassagewayCode="payPassagewayCode" />
    </el-dialog>
  </div>
</template>
<script>
import { dictionaries } from '@/api/ajax';
import rechargeRecord from './rechargeRecord';
import { payBankFormatter } from '@/common/fields/bank';

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: true
    },
    rechargeObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    BANK_MAPPING() {
      return this.$store.state.bank.banks;
    }
  },
  data() {
    return {
      payBankFormatter,
      ruleForm: {},
      tableData: [],
      loading: false,
      showMore: false,
      payPassagewayCode: this.rechargeObj.payPassagewayCode
    };
  },
  components: {
    rechargeRecord
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    },
    confirm() {
      this.$parent.componentName = '';
    },
    async getTableData() {
      const {
        data: {
          data: { rechargeList, ...ruleForm }
        }
      } = await dictionaries.recharge({
        payPassagewayCode: this.payPassagewayCode
      });
      this.ruleForm = ruleForm;
      this.tableData = rechargeList;
    }
  },
  async created() {
    this.getTableData();
  }
};
</script>
<style lang="scss" scoped>
.colorBlock {
  color: #2e2f2f;
  font-size: 20px;
  margin-bottom: 30px;
  position: relative;
  padding-left: 16px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.colorBlock::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.cont {
  margin-bottom: 25px;
  text-align: left;
  margin-left: 20%;
  span {
    color: #bfbfbf;
    font-size: 14px;
    width: 80px;
    text-align: right;
    display: inline-block;
  }
  b {
    font-weight: normal;
    color: #2e2f2f;
    font-size: 14px;
  }
}
</style>
